






































import mixins from 'vue-typed-mixins'
import VisibleColumns from '@/abstract/VisibleColumns'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import DataTableMobileSorting from '@/components/DataTable/DataTableMobileSorting.vue'
import RowView from '@/components/DataTable/Columns/RowView.vue'
import Draggable from 'vuedraggable'
import iconArrowExpand from '@/assets/svg/rounded/arrow-expand.svg?inline'
import iconArrowDown from '@/assets/svg/rounded/arrow-down.svg?inline'
import iconExpandRow from '@/assets/svg/rounded/expand-row.svg?inline'
import iconCropRow from '@/assets/svg/rounded/cropped-row.svg?inline'
import vClickOutside from 'v-click-outside'
import { DataTableColumnItem } from '@/models/dataTable'
import { ESortDir } from '@/constants/dataTable'

interface Props {
  allColumns: Array<DataTableColumnItem>
  directory: string
  position: string
  tableId: string
}

interface Methods {
  setOrderQuery: () => void
  setSortQuery: (direction: ESortDir, column: DataTableColumnItem) => void
  isActive: (direction: ESortDir, column: DataTableColumnItem) => boolean
  hideColumnSort: () => void
  toggleColumnSort: () => void
  disableCheckbox: (visible: boolean) => boolean
  setColumns: () => void
}

interface Data {
  directions: ESortDir[]
  showColumnSort: boolean
  columns: Array<DataTableColumnItem>
}

interface Computed {
  limitColumnsIsFull: boolean
  limitColumnIsEmpty: boolean
}

export default mixins(WindowResizeListener, VisibleColumns).extend<
  Data,
  Methods,
  Computed,
  Props
>({
  components: {
    Draggable,
    PaidLabel,
    CustomCheckbox,
    iconArrowExpand,
    DataTableMobileSorting,
    RowView,
    iconArrowDown,
    iconExpandRow,
    iconCropRow,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    allColumns: {
      required: true,
    },
    directory: {
      required: true,
    },
    position: {
      required: false,
      default: 'absolute',
    },
    tableId: {
      required: false,
      default: '',
    },
  },
  data() {
    return {
      columns: [],
      directions: Object.values(ESortDir),
      showColumnSort: false,
    }
  },

  methods: {
    setOrderQuery() {
      const query = Object.assign({}, this.$route.query)
      let columns = ''
      this.columns.forEach(elem => {
        if (elem.visible) {
          columns = `${columns},${elem.key}`
        }
      })
      columns = columns.slice(1)
      query[`columns${this.tableId}`] = columns
      if (columns.length === 0) {
        delete query[`columns${this.tableId}`]
      }
      if (columns !== this.$route.query[`columns${this.tableId}`]) {
        this.$router.push({ query: { ...query } })
      }
      this.columns.sort((a, b) => {
        return Number(b.visible) - Number(a.visible)
      })
    },
    setColumns() {
      this.columns = this.allColumns.map(elem => Object.assign({}, elem))
      this.columns.sort((a, b) => {
        return Number(b.visible) - Number(a.visible)
      })
    },
    setSortQuery(direction, column) {
      this.$router.push({
        query: {
          ...this.$route.query,
          sort: `${column.key}:${direction}`,
        },
      })
    },
    isActive(direction, column) {
      if (this.$route.query.sort) {
        const sort = (this.$route.query.sort as string).split(':')
        return sort[0] === column.key && sort[1] === direction
      }
      return false
    },
    hideColumnSort() {
      if (!this.isMobile) {
        this.showColumnSort = false
        this.$emit('input', this.showColumnSort)
      }
    },
    toggleColumnSort() {
      this.showColumnSort = !this.showColumnSort
      this.$emit('input', this.showColumnSort)
    },
    disableCheckbox(visible) {
      return !visible && this.limitColumnsIsFull
    },
  },
  computed: {
    limitColumnsIsFull() {
      const visibleColumns = this.columns.filter(elem => {
        return elem.visible
      })
      return visibleColumns.length >= 100
    },
    limitColumnIsEmpty() {
      const visibleColumns = this.columns.filter(elem => {
        return elem.visible
      })
      return visibleColumns.length <= 1
    },
  },
  watch: {
    allColumns() {
      if (
        this.columns.filter(elem => elem.visible).length !==
        this.allColumns.filter(elem => elem.visible).length
      ) {
        this.setColumns()
      }
    },
  },
  mounted() {
    this.setColumns()
  },
})
